import { useState, useEffect, useRef } from "react";

const useObserver = (loadMore, options, target, data) => {
  let loadMoreHook = useRef(null);

  useEffect(() => {
    loadMoreHook.current = loadMore;
  }, [data, loadMore]);

  const callbackFunction = (entries) => {
    // A veces el array devuelve dos observadores cuando el muy chico el navbar
    // Tenemos que coger el ultimo
    const entry = entries[entries.length - 1];
    if (entry.isIntersecting) {
      loadMoreHook.current();
    }
  };

  const [observer, setObserver] = useState(new IntersectionObserver(callbackFunction, options));

  useEffect(() => {
    setObserver(new IntersectionObserver(callbackFunction, options));
    if (target.current) {
      observer.observe(target.current);
    }
    return function cleanUp() {
      if (observer) {
        observer.disconnect();
      }
    };
  }, [target.current]);

  return { observer: observer };
};

export default useObserver;